import { doRequestReturnStandard, doRequestSimple, doRequestWithResponse } from '.';
import { baseApiUrl, requestOptionsDelete, requestOptionsGet, requestOptionsPost, requestOptionsPut } from '../_constants/emparkConstants';

/* Parameters */
export async function getParameters(contextId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters`;

    return await doRequestWithResponse(apiUrl, requestOptionsGet());
}

export async function createParameter(contextId, parameter) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(parameter) });
}

export async function updateParameter(contextId, parameterId, parameter) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(parameter) });
}

export async function deleteParameter(contextId, parameterId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

/* RateMapping mappings */
export async function getRateMappings(contextId, parameterId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rates`;

    return await doRequestWithResponse(apiUrl, requestOptionsGet());
}

export async function createRateMapping(contextId, parameterId, rateMapping) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rates`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(rateMapping) });
}

export async function updateRateMapping(contextId, parameterId, rateMappingId, rateMapping) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rates/${rateMappingId}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(rateMapping) });
}

export async function deleteRateMapping(contextId, parameterId, rateId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rates/${rateId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}

/* Rule mappings */
export async function getRules(contextId, parameterId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rules`;

    return await doRequestWithResponse(apiUrl, requestOptionsGet());
}

export async function createRule(contextId, parameterId, ruleMapping) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rules`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPost(), body: JSON.stringify(ruleMapping) });
}

export async function updateRule(contextId, parameterId, ruleMappingId, ruleMapping) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rules/${ruleMappingId}`;

    return await doRequestWithResponse(apiUrl, { ...requestOptionsPut(), body: JSON.stringify(ruleMapping) });
}

export async function deleteRule(contextId, parameterId, ruleId) {
    const apiUrl = `${baseApiUrl}contexts/${contextId}/fare_parameters/${parameterId}/rules/${ruleId}`;

    return await doRequestSimple(apiUrl, requestOptionsDelete());
}
